import React from "react";
import "./Sidebar.css";
import { Link, useNavigate } from "react-router-dom";
import { UserRound, UserRoundPlus } from "lucide-react";

import TravelAgency from "../../assets/travel-agency.svg";
import Home from "../../assets/home.svg";
import EmAndamento from "../../assets/em-andamento.svg";
import Cancel from "../../assets/cancel.svg";

const SidebarReceiver = ({ menuOpen, setMenuOpen }) => {
  const navigate = useNavigate();
  const handleCloseMenu = () => setMenuOpen(false);

  return (
    <>
      <div
        className={`mobile-overlay ${menuOpen ? "show" : ""}`}
        onClick={handleCloseMenu}
      />

      <aside className={`sidebar ${menuOpen ? "open" : "closed"}`}>
        <button
          className="desktop-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? "❮" : "❯"}
        </button>

        <nav>
          <ul>
            <li
              className="active"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-receiver");
              }}
            >
              <img src={Home} className="sidebar-icon" alt="" />
              Início
            </li>

            <li
              onClick={() => {
                handleCloseMenu();
                navigate("/trips-progress-receiver");
              }}
            >
              <img src={EmAndamento} className="sidebar-icon" alt="" />
              Encomendas em Andamento
            </li>

            <li
              onClick={() => {
                handleCloseMenu();
                navigate("/trips-concluded-receiver");
              }}
            >
              <img src={TravelAgency} className="sidebar-icon" alt="" />
              Encomendas Recebidas
            </li>

            <li onClick={handleCloseMenu}>
              <img src={Cancel} className="sidebar-icon" alt="" />
              Encomendas não Efetivadas
            </li>

            <div className="sidebar-section-title">PAINEIS DE CONTROLE</div>

            <li
              className="special-panel panell"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-client");
              }}
            >
              <UserRound size={40} strokeWidth={2.5} className="tag-icon" />
              <div className="panel-text">
                <strong>Painel do Cliente</strong>
              </div>
            </li>

            <li
              className="special-panel panell"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-traveler");
              }}
            >
              <UserRoundPlus size={50} strokeWidth={2.5} className="tag-icon" />
              <div className="panel-text">
                <strong>Painel do Viajante</strong>
              </div>
            </li>
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default SidebarReceiver;
